<!--订单查询 其他-->
<template>
  <div>
    <app-breadcrumb />
    <div class="page-container orderquery-others">
      <p>
        {{this.$t('*Max. 3 modification opportunities for one invoice.')}}
      </p>
      <p>
        {{this.$t('Modify consignee information')}}
      </p>
      <hr>
      <el-form v-loading="lsitloading" label-width="150px">
        <!--        收货地址-->
        <el-form-item :label="$t('ssCustomer.saddress')">
            <!--            国-->
            <el-select size="mini" style="width: 160px" v-model="listQuery.country" clearable :placeholder="$t('please.select.country.or.region')" @change="getProvince">
              <el-option value="" />
              <el-option  v-for="role in country" :key="role.regionId" :label="(role.regionName)" :value="role.regionId.toString()"  />
            </el-select>
            <!--            省-->
            <el-select size="mini" v-loading="sltloading" style="width: 160px" v-model="listQuery.province" clearable :placeholder="$t('please.select.province')" @change="getcity">
              <el-option value="" />
              <el-option v-for="role in province" :key="role.regionId" :label="(role.regionName)" :value="role.regionId.toString()" />
            </el-select>
            <!--            市-->
            <el-select size="mini" v-loading="sltloading" style="width: 160px" v-model="listQuery.city" clearable :placeholder="$t('please.select.city')" >
              <el-option value="" />
              <el-option v-for="role in city" :key="role.regionId" :label="(role.regionName)" :value="role.regionId.toString()" />
            </el-select>
          <br>
            <el-input size="mini" style="width: 50%;" v-model.trim="listQuery.recA" clearable :placeholder="$t('')"  />
        </el-form-item>
        <el-form-item :label="$t('Zip Code')">
          <el-input size="mini" style="width: 50%;" v-model.trim="listQuery.pzip" clearable :placeholder="$t('')"  />
        </el-form-item>
        <el-form-item :label="$t('Contact No.')">
          <el-input size="mini" style="width: 50%;" v-model.trim="listQuery.pcon" clearable :placeholder="$t('')"  />
        </el-form-item>
        <el-form-item :label="$t('GSTIN/UIN')">
          <el-input size="mini" style="width: 50%;" v-model.trim="listQuery.uinr" clearable :placeholder="$t('')"  />
        </el-form-item>
        <p>{{this.$t('Modify buyer information')}}</p>
        <hr>
        <!--        收货地址-->
        <el-form-item :label="$t('ssCustomer.saddress')">
          <!--            国-->
          <el-select size="mini" style="width: 160px" v-model="listQuery.country1" clearable :placeholder="$t('please.select.country.or.region')" @change="getProvince1">
            <el-option value="" />
            <el-option  v-for="role in country1" :key="role.regionId" :label="role.regionName" :value="role.regionId.toString()"  />
          </el-select>
          <!--            省-->
          <el-select size="mini" v-loading="sltloading1" style="width: 160px" v-model="listQuery.province1" clearable :placeholder="$t('please.select.province')" @change="getcity1">
            <el-option value="" />
            <el-option v-for="role in province1" :key="role.regionId" :label="role.regionName" :value="role.regionId.toString()" />
          </el-select>
          <!--            市-->
          <el-select size="mini" v-loading="sltloading1" style="width: 160px" v-model="listQuery.city1" clearable :placeholder="$t('please.select.city')" >
            <el-option value="" />
            <el-option v-for="role in city1" :key="role.regionId" :label="role.regionName" :value="role.regionId.toString()" />
          </el-select>
          <br>
          <el-input size="mini" style="width: 50%;" v-model.trim="listQuery.recAddr" clearable :placeholder="$t('')"  />
        </el-form-item>
        <el-form-item :label="$t('Zip Code')">
          <el-input size="mini" style="width: 50%;" v-model.trim="listQuery.mzip" clearable :placeholder="$t('')"  />
        </el-form-item>
        <el-form-item :label="$t('Contact No.')">
          <el-input size="mini" style="width: 50%;" v-model.trim="listQuery.mcon" clearable :placeholder="$t('')"  />
        </el-form-item>
        <el-form-item :label="$t('GSTIN/UIN')">
          <el-input size="mini" style="width: 50%;" v-model.trim="listQuery.uin" clearable :placeholder="$t('')"  />
        </el-form-item>
        <div style="text-align: center; margin-bottom: 10px;margin-top: 10px" >
          <el-button size="mini" icon="el-icon-check" :loading="btnloading" type="warning" @click="submit">{{ $t('title.submit') }}</el-button>
          <el-button size="mini" icon="el-icon-close"  @click="$router.back(-1)">{{ $t('operation.button.cancel') }}</el-button>
        </div>
      </el-form>
    </div>
  </div>
</template>

<script>
import {editAddrAndUIN, orderAddr} from "@/api/ay-business-manager/orderquery";
import {getAlRegionsByID, getLevel1AlRegions} from "@/api/member";

export default {

  name: "OrderQueryOthers",
  data(){
    return{
      listQuery:{
        country:null,
        province:null,
        city:null,
        country1:null,
        province1:null,
        city1:null,
      },
      lsitloading:false,
      btnloading:false,
      sltloading:false,
      country:[],
      province:[],
      city:[],
      sltloading1:false,
      country1:[],
      province1:[],
      city1:[],
    }
  },
  created() {
    this.getCountry()
  },
  mounted() {
    this.orderAddr(this.$route.params.id)
  },
  methods:{
    //国
    getCountry(){
      this.sltloading = true
      getLevel1AlRegions().then(res=>{
        this.country1 = this.country = res.data
        this.sltloading = false
      }).catch(err=>{
        this.sltloading = false
        console.error(err)
      })
    },
    //省
    getProvince(){
      this.province = null
      this.city = null
      this.listQuery.province = null
      this.listQuery.city = null
      this.sltloading = true
      getAlRegionsByID({'regionId':this.listQuery.country}).then(res=>{
        this.province = res.data
        this.sltloading = false
      }).catch(err=>{
        console.error(err)
        this.sltloading = false
      })
    },
    //市
    getcity(){
      this.city = null
      this.sltloading = true
      this.listQuery.city = null
      getAlRegionsByID({'regionId':this.listQuery.province}).then(res=>{
        this.city = res.data
        this.sltloading = false
      }).catch(err=>{
        this.sltloading = false
        console.error(err)
      })
    },
    //省
    getProvince1(){
      this.province1 = null
      this.city1 = null
      this.listQuery.province1 = null
      this.listQuery.city1 = null
      this.sltloading = true
      getAlRegionsByID({'regionId':this.listQuery.country1}).then(res=>{
        this.province1 = res.data
        this.sltloading = false
      }).catch(err=>{
        console.error(err)
        this.sltloading = false
      })
    },
    //市
    getcity1(){
      this.city1 = null
      this.listQuery.city1 = null
      this.sltloading = true
      getAlRegionsByID({'regionId':this.listQuery.province1}).then(res=>{
        this.city1 = res.data
        this.sltloading = false
        console.log(res)
      }).catch(err=>{
        console.error(err)
        this.sltloading = false
      })
    },
    orderAddr(val){
      this.lsitloading = true
      orderAddr({'id':val}).then(async res=>{
        // console.log(res)
        if(res.data.country){
          await getAlRegionsByID({'regionId':res.data.country}).then(res=>{
            this.province = res.data
          }).catch(err=>{
            console.error(err)
          })
        }
        if(res.data.province){
          await getAlRegionsByID({'regionId':res.data.province}).then(res=>{
            this.city = res.data
            console.log(res)
          }).catch(err=>{
            console.error(err)
          })
        }
        if(res.data.country1){
          await getAlRegionsByID({'regionId':res.data.country1}).then(res=>{
            this.province1 = res.data
          }).catch(err=>{
            console.error(err)
          })
        }
        if(res.data.province1){
          await getAlRegionsByID({'regionId':res.data.province1}).then(res=>{
            this.city1 = res.data
          }).catch(err=>{
            console.error(err)
          })
        }
        this.listQuery.province = res.data.province
        this.listQuery.province1 = res.data.province1
        this.listQuery.city = res.data.city
        this.listQuery.city1 = res.data.city1
        this.listQuery.country = res.data.country
        this.listQuery.country1 = res.data.country1
        this.listQuery = res.data
        this.lsitloading = false
      }).catch(err=>{
        console.error(err)
        this.$router.back()
      })
    },
    submit(){
      this.btnloading = true
      this.listQuery.id = this.$route.params.id
      editAddrAndUIN({...this.listQuery}).then(res=>{
        this.$message.success(this.$t('bdSendRegister.operaterSuccess'))
        console.log(res)
        this.btnloading = false
        this.$router.push({name:'OrderQuery'})
      }).catch(err=>{
        this.btnloading = false
        this.$message.error(this.$t('bdSendRegister.operaterFail'))
        console.error(err)
      })
    }
  }
}
</script>

<style scoped>

</style>
